module.exports = __webpack_public_path__ + "img/july-3.4a01d384.jpg";